<template>
  <section style="padding: 40px 0px; background-color: #F7F7F7">
    <bl-flex-container-mv justify-content="center" style="width: 100%;">
      <bl-flex-item-av class="mr-64">
        <bl-text-av tag="h2" class="mb-16" style="font-size: 26px; line-height: 32px; font-weight: normal;">
          {{ aperd.title }}
        </bl-text-av>
        <bl-flex-container-mv align-items="center">
          <bl-flex-item-av v-for="(logo, index) in aperd.logoUrls" :key="index">
            <new-webp-image-container
              :alt="logo.alt"
              :src="`partner_logos/${logo.src}`"
              :is-ssr="isSSR"
              styles="max-width: 150px;"
              :style="index !== 0 ? 'margin-left: 36px' : ''"
            />
          </bl-flex-item-av>
        </bl-flex-container-mv>
      </bl-flex-item-av>

      <bl-flex-item-av class="ph-64" style="border-right: 1px solid #D6D6D6; border-left: 1px solid #D6D6D6">
        <bl-text-av tag="h2" class="mb-16" style="font-size: 26px; line-height: 32px; font-weight: normal;">
          {{ ojk.title }}
        </bl-text-av>
        <new-webp-image-container
          :alt="ojk.logoUrl.alt"
          :src="`partner_logos/${ojk.logoUrl.src}`"
          :is-ssr="isSSR"
          styles="max-width: 150px;"
        />
      </bl-flex-item-av>

      <bl-flex-item-av class="ml-64">
        <bl-text-av tag="h2" class="mb-16" style="font-size: 26px; line-height: 32px; font-weight: normal;">
          {{ partner.title }}
        </bl-text-av>
        <new-webp-image-container
          v-for="(logo, index) in partner.logoUrls"
          :key="index"
          :alt="logo.alt"
          :src="`partner_logos/${logo.src}`"
          :is-ssr="isSSR"
          styles="max-width: 150px;"
        />
      </bl-flex-item-av>
    </bl-flex-container-mv>
  </section>
</template>

<script>
/* istanbul ignore file */
import { Footer as footer } from 'shared/modules/seo/Homepage';
import BlFlexContainerMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexItemAv';
import BlTextAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlTextAv';
import NewWebpImageContainer from 'shared/components/NewWebpImageContainer';

export default {
  name: 'Footer',

  footer,

  components: {
    BlFlexContainerMv,
    BlFlexItemAv,
    BlTextAv,
    NewWebpImageContainer,
  },

  computed: {
    isSSR() {
      return this.$root.isSSR;
    },

    aperd() {
      return this.$options.footer.aperd;
    },

    ojk() {
      return this.$options.footer.ojk;
    },

    partner() {
      return this.$options.footer.partner;
    },
  },
};
</script>
